// ----------------------------------------------------------------------

import { buttonClasses } from "@mui/material";

export function card(theme) {
    return {
        MuiCard: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    position: "relative",
                    borderRadius: theme.shape.borderRadius * 1.5,
                    zIndex: 0, // Fix Safari overflow: hidden with border radius
                    boxShadow: ownerState.variant === "outlined" ? "none" : theme.customShadows.z1,
                    backgroundColor: theme.palette.background.paperLowest,
                }),
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(3, 3, 0),
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(3),
                },
            },
        },
        MuiCardActionArea: {
            styleOverrides: {
                root: {
                    [`&.${buttonClasses.disabled}`]: {
                        pointerEvents: "auto",
                        cursor: "not-allowed",
                        boxShadow: "none",
                    },
                },
            },
        },
    };
}
